export const upData = [
{
    "id":"1",
    "name":"Kaju Upma ",
    "price":"Price :₹75",
    "image": process.env.PUBLIC_URL + "/assests/upma/1.png",
    "description": "Rich and savory semolina upma roasted in pure ghee and loaded with crunchy cashew nuts."
},
{
    "id":"2",
    "name":"Sooji Upma ",
    "price":"Price :₹60",
    "image": process.env.PUBLIC_URL + "/assests/upma/3.png",
    "description": "A traditional, heartwarming breakfast made from roasted semolina cooked with mustard seeds, crunchy chana dal, fresh curry leaves, and green chilies."
},
{
    "id":"3",
    "name":"Oats Upma ",
    "price":"Price :₹75",
    "image": process.env.PUBLIC_URL + "/assests/upma/2.png",
    "description": "A healthy, nutrient-packed twist on the classic upma, featuring wholesome rolled oats dry-roasted and tossed with plenty of colorful, crunchy vegetables."
}]